<template>
  <b-card
    no-body
    class="mb-2 shadow-sm border-0 ai-card consistent-card"
    role="region"
    aria-label="Triangulation: all sources consistent"
  >
    <div class="card-body p-3">
      <div class="d-flex align-items-center mb-2">
        <b-icon-check-circle class="mr-2 text-success" font-scale="1.2" aria-hidden="true" />
        <h6 class="m-0 font-weight-bold text-uppercase" style="font-size: 13px;">All sources consistent</h6>
        <b-badge variant="success" class="ml-auto">Within threshold</b-badge>
        <b-icon-info-circle class="ml-2 text-muted" v-b-tooltip.hover.html="tooltipHtml" />
      </div>
      <p class="small mb-0 text-muted">
        Largest spread across selected sources is about <strong>{{ triangulation.diffPercent }}%</strong>
        (threshold {{ triangulation.threshold }}%).
      </p>
      <p v-if="explanation" class="small mb-0 mt-2">
        {{ explanation }}
      </p>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'ConsistentSourcesCard',
  props: {
    triangulation: {
      type: Object,
      required: true,
    },
    explanation: {
      type: String,
      default: '',
    },
    whyMatters: {
      type: String,
      default: '',
    },
  },
  computed: {
    tooltipHtml() {
      const w = this.whyMatters ? `<div class="mt-1"><em>Why this matters:</em> ${this.whyMatters}</div>` : '';
      return `${this.explanation || ''}${w}`;
    },
  },
};
</script>

<style scoped>
.ai-card {
  cursor: default;
}
.consistent-card {
  border-left: 4px solid #28a745 !important;
}
</style>
